export default "__VITE_ASSET__CtTuxI4H__"